const AWS_REGION = 'eu-west-1';

// Determine bucket name based on environment, matching the pattern used in config.ts
const getBucketName = (): string => {
  // Allow explicit override via environment variable
  if (import.meta.env.VITE_APPROVED_ASSET_BUCKET) {
    return import.meta.env.VITE_APPROVED_ASSET_BUCKET.trim();
  }

  const mode = import.meta.env.MODE;
  const isProd = import.meta.env.PROD || mode === 'production';
  const isStaging = mode === 'staging';

  if (isProd) {
    return 'irl-signup-app-prod-assets-approved';
  }
  
  if (isStaging) {
    return 'irl-signup-app-staging-assets-approved';
  }

  // Default to dev bucket for development, local, etc.
  return 'irl-signup-app-dev-assets-approved';
};

const bucketName = getBucketName();
const httpRoot = `https://${bucketName}.s3.${AWS_REGION}.amazonaws.com/assets`;
const s3Root = `s3://${bucketName}/assets`;

export const approvedAssetRoots = {
  http: httpRoot,
  s3: s3Root,
  bucket: bucketName,
};

export const buildApprovedAssetUrls = (relativePath: string) => {
  const normalized = relativePath.replace(/^\/+/, '');
  return {
    httpUrl: `${httpRoot}/${normalized}`,
    s3Path: `${s3Root}/${normalized}`,
  };
};

